module.exports = "/_next/static/images/AccessibleAiImage-b065f3dd658c58380fbb1f64dec6ca0d.webp";